module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAM1BMVEUAAAD///////////////////////////////////////////////////////////////+3leKCAAAAEHRSTlMAgMA/sHBgMCDwkFDg0KAQl0x5XgAAAGtJREFUGNOtj1kKwDAIRM1itm5z/9NWWmlMC/nqgxF8CIM0I1/jGGVq3nN6ubUCdVusK4gRklqM3KE4U5KDkklvE9hD8Yy7zcF1KcsfckGyRc8DXVInQon2zQCwJBSyiJDQCJC/khtRczThBFe3B+OPx+r8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/android.png
// module id = LbF0
// module chunks = 21